import React, { useState } from 'react';
import moment from 'moment';

import useGlobal from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';
import { useMemo } from 'react';

const mapState = (state) => {
  return state.app.retenciones.list;
};

const mapActions = (actions) => {
  return actions.app.retenciones.list;
};

const RetencionSearch = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { filters, filters: { search, from: asFrom, to: asTo } } = state;

  const from = !!asFrom ? moment(asFrom): moment().subtract(7, 'days');
  const to =  !!asTo ? moment(asTo) : moment();

  const [date, setDate] = useState([
    from.toDate(),
    to.toDate()
  ]);

  const handleOnKeywordChange = (keyword) => {
    actions.paginate({
      ...filters,
      search: keyword
    });
  }

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  }

  const handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    setDate(date);

    actions.paginate({
      ...filters,
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD')
    });
  }

  const Search = (
    <div className="d-flex flex-column flex-sm-row">
      <div className="pr-2 pb-2">
        <CalendarDateRangePicker
          value={ date }
          onDateChange={ handleOnDateChange }
        />
      </div>
      <div className="flex-fill search-container">
        <SearchInput
          onKeywordChange={ handleOnKeywordChange }
          onClear={ handleOnSearchClear }
          value={ search || '' }
        />
      </div>
    </div>
  );

  return useMemo(() => Search, [asFrom, asTo, search]); // eslint-disable-line react-hooks/exhaustive-deps
}

export default RetencionSearch;